var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.1402C0 10.3602 10.3602 0 23.1402 0C35.9201 0 46.2803 10.3602 46.2803 23.1402C46.2803 35.9201 35.9201 46.2803 23.1402 46.2803C10.3602 46.2803 0 35.9201 0 23.1402Z",
    fill: "#FFCB42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6097 15.6842L31.8853 31.3833C31.6043 32.4913 30.8716 32.767 29.8303 32.245L24.1556 28.5074L21.4174 30.8613C21.1144 31.1321 20.861 31.3586 20.277 31.3586L20.6847 26.1929L31.2021 17.6983C31.6594 17.3339 31.103 17.132 30.4914 17.4964L17.4892 24.8141L11.8916 23.2481C10.674 22.9083 10.652 22.1598 12.1451 21.6378L34.0395 14.0985C35.0532 13.7587 35.9402 14.3004 35.6097 15.6842Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.9b51b98d93cda6be80a948d6ae56a833.svg";
export { ForwardRef as ReactComponent };